var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"viewer",rawName:"v-viewer",value:({ toolbar: true, navbar: false, title: false }),expression:"{ toolbar: true, navbar: false, title: false }"}],staticClass:"images clearfix",on:{"ready":_vm.readys,"shown":_vm.shown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }